var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrxInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#B8DDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6561 7.36269C14.6311 7.51894 14.6186 7.67519 14.6186 7.83144C14.6186 9.23769 15.7561 10.3746 17.1561 10.3746C17.3123 10.3746 17.4623 10.3564 17.6186 10.3314V15.3746C17.6186 17.4939 16.3686 18.7502 14.2436 18.7502H9.62544C7.49982 18.7502 6.24982 17.4939 6.24982 15.3746V10.7502C6.24982 8.62519 7.49982 7.36269 9.62544 7.36269H14.6561ZM14.7817 11.1627C14.6123 11.1439 14.4442 11.2189 14.3436 11.3564L12.8317 13.3127L11.0998 11.9502C10.9936 11.8689 10.8686 11.8371 10.7436 11.8502C10.6192 11.8689 10.5067 11.9371 10.4311 12.0371L8.58169 14.4439L8.54357 14.5002C8.43732 14.6996 8.48732 14.9558 8.67482 15.0939C8.76232 15.1502 8.85607 15.1877 8.96232 15.1877C9.10669 15.1939 9.24357 15.1183 9.33107 15.0002L10.8998 12.9808L12.6811 14.3189L12.7373 14.3558C12.9373 14.4621 13.1873 14.4127 13.3311 14.2246L15.1373 11.8939L15.1123 11.9064C15.2123 11.7689 15.2311 11.5939 15.1623 11.4377C15.0942 11.2814 14.9436 11.1752 14.7817 11.1627ZM17.2436 6.25C18.0749 6.25 18.7499 6.925 18.7499 7.75625C18.7499 8.5875 18.0749 9.2625 17.2436 9.2625C16.4124 9.2625 15.7374 8.5875 15.7374 7.75625C15.7374 6.925 16.4124 6.25 17.2436 6.25Z",
    fill: "#0085FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrxInIcon);
export default __webpack_public_path__ + "static/media/trx-in-icon.580f167bef159ad9bec6bd1797e835da.svg";
export { ForwardRef as ReactComponent };